// Central JayesPay brand & company data
export const COMPANY = {
  name: "JayesPay",
  attribution: "JayesPay — A product of Velariti Software Solutions Private Limited",
  legalName: "Velariti Software Solutions Private Limited",
  cin: "U58200BR2024PTC072222",
  foundedYear: "2024",
  email: "care@jayespay.com",
  phone: "+91 7322972153",
  address:
    "C/O Munnilal Prasad, Village Bahabalpur, Guraru Mills, Gaya, Guraru, Bihar, India, 824118",
  logo: "https://jayespay.b-cdn.net/assets/media/main-logo.png",
  footerLogo: "https://cdn.jayespay.com/assets/media/logo_light.png",
  icon: "https://jayespay.b-cdn.net/assets/media/main-icon.png",
  directors: [
    {
      name: "Govind Prasad",
      din: "09117311",
      designation: "Director",
      appointedOn: "18 Nov 2024",
    },
    {
      name: "Balmiki Kumar",
      din: "10840906",
      designation: "Director",
      appointedOn: "18 Nov 2024",
    },
  ],
};

export const APP_URLS = {
  login: "https://app.jayespay.com/login/",
  register: "https://app.jayespay.com/register/",
};

export const PLAY_STORE_PACKAGE_ID = "com.velariti.vsaathi";

export function buildPlayStoreUrl(referralCode) {
  const base = `https://play.google.com/store/apps/details?id=${PLAY_STORE_PACKAGE_ID}`;
  const code = (referralCode || "").trim();

  if (!code) {
    return base;
  }

  return `${base}&referrer=${encodeURIComponent(`referral_code=${code}`)}`;
}

export const SOCIAL_LINKS = [
  { label: "YouTube", url: "https://youtube.com/@jayespay", icon: "YoutubeLogo" },
  { label: "Facebook", url: "https://www.facebook.com/jayespay", icon: "FacebookLogo" },
  { label: "Instagram", url: "https://www.instagram.com/jayespay", icon: "InstagramLogo" },
  { label: "Threads", url: "https://www.threads.net/@jayespay", icon: "ThreadsLogo" },
  { label: "X", url: "https://x.com/jayespay", icon: "XLogo" },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Features", to: "/features" },
  { label: "Packages", to: "/packages" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const ACTIVE_SERVICES = [
  {
    id: "recharge",
    title: "Recharge",
    description:
      "Mobile, DTH and FasTAG recharge with auto operator-circle detection, browse plans and R-Offer.",
    badge: "Live",
    items: [
      "Mobile Recharge (Auto-Detect, Plans, R-Offer)",
      "DTH Recharge (Browse Plans)",
      "FasTAG Recharge",
    ],
    icon: "Phone",
  },
  {
    id: "bill",
    title: "Bill Payments",
    description:
      "Pay utility, gas, insurance and loan EMIs with instant bill-fetch and complete due-date details.",
    badge: "Live",
    items: [
      "Electricity Bill Payment",
      "LPG Gas Booking",
      "Piped Gas Bill Payment",
      "Loan EMI Repayment",
      "Insurance Premium Repayment",
    ],
    icon: "Lightning",
  },
  {
    id: "pan",
    title: "PAN Card",
    description:
      "Apply for new PAN or correct existing one, powered by NSDL and UTI partners.",
    badge: "Live",
    items: ["NSDL Apply & Correction", "UTI Apply & Correction"],
    icon: "IdentificationCard",
  },
  {
    id: "bc",
    title: "NSDL Bank BC",
    description:
      "Become a Banking Correspondent — open Saving and Current accounts via NSDL Payments Bank.",
    badge: "Live",
    items: ["Saving Account Opening", "Current Account Opening"],
    icon: "Bank",
  },
  {
    id: "rd",
    title: "Recurring Deposit",
    description:
      "Daily, Weekly and Monthly RD accounts with installment, statement, account kit and closure.",
    badge: "Live",
    items: [
      "Open RD (Daily / Weekly / Monthly)",
      "Manage RD Accounts",
      "Pay Installment",
      "Account Statement",
      "Account Kit",
      "Close RD Account",
    ],
    icon: "PiggyBank",
  },
];

export const UPCOMING_SERVICES = [
  { title: "DMT — Money Transfer", icon: "PaperPlaneTilt" },
  { title: "AePS", icon: "Fingerprint" },
  { title: "AePS Cash Deposit", icon: "Money" },
  { title: "m-ATM", icon: "CreditCard" },
  { title: "UPI Cashout", icon: "QrCode" },
  { title: "Aadhaar Pay", icon: "Fingerprint" },
  { title: "Insurance", icon: "ShieldCheck" },
  { title: "CMS — Cash Collection", icon: "Receipt" },
  { title: "IRCTC e-Ticketing", icon: "Train" },
  { title: "Flight Booking", icon: "AirplaneTakeoff" },
  { title: "Bus Booking", icon: "Bus" },
  { title: "Digital Gold", icon: "Coins" },
  { title: "Personal Loan", icon: "HandCoins" },
  { title: "Business Loan", icon: "Buildings" },
  { title: "Credit Card", icon: "CreditCard" },
  { title: "Saving & Current A/C (Partner Banks)", icon: "Bank" },
];

export const APP_FEATURES = [
  {
    title: "Smart Dashboard",
    description:
      "Latest notifications, sliding service updates, favourite services and the full catalogue — at a glance.",
    icon: "SquaresFour",
  },
  {
    title: "Powerful Reports",
    description:
      "Ledger Book, Business Report, Add Money Report and Service-Wise Report for full transaction visibility.",
    icon: "ChartBar",
  },
  {
    title: "Smart Wallet",
    description:
      "A unified retailer wallet with multiple add-money methods — Manual Request, UPI/Bank Transfer and Instant UPI Payment.",
    icon: "Wallet",
  },
  {
    title: "Package & Upgrades",
    description:
      "Purchase a service package to activate services, upgrade anytime as your retail business grows.",
    icon: "Package",
  },
  {
    title: "Retailer Profile Kit",
    description:
      "Download a branded company ID Card and your authorised Retailer Certificate in one tap.",
    icon: "IdentificationBadge",
  },
  {
    title: "Refer & Earn",
    description:
      "Track referrals by name, KYC, package status and earned commission with a transparent structure.",
    icon: "UsersThree",
  },
  {
    title: "Bank-Grade Security",
    description:
      "Change password, T-PIN (Set / Reset / Change) and App Lock with 4-digit PIN or device lock.",
    icon: "ShieldCheck",
  },
  {
    title: "Granular Settings",
    description:
      "Hide coming-soon services, mask balance and commission, Bank Master and per-service commission view.",
    icon: "SlidersHorizontal",
  },
  {
    title: "Support That Listens",
    description:
      "Call-back requests, support tickets, customer care and distributor contact — all in one place.",
    icon: "Headset",
  },
];

export const HOW_IT_WORKS = [
  {
    step: "01",
    title: "Register",
    description: "Sign up as a retailer with your email and mobile number.",
  },
  {
    step: "02",
    title: "Verify",
    description: "Confirm OTP on email & mobile — account is activated instantly.",
  },
  {
    step: "03",
    title: "Complete KYC",
    description:
      "Basic Info, Aadhaar eKYC, PAN & Bank verification, and upload documents.",
  },
  {
    step: "04",
    title: "Activate Package",
    description: "Pick a service package that fits your retail outlet.",
  },
  {
    step: "05",
    title: "Add Money",
    description: "Top-up via Manual Request, UPI/Bank Transfer or Instant UPI.",
  },
  {
    step: "06",
    title: "Start Transacting",
    description: "Serve customers — recharge, bills, PAN, RD, BC and more.",
  },
];

export const STATS = [
  { value: "5+", label: "Live Services" },
  { value: "17+", label: "Upcoming Services" },
  { value: "24×7", label: "Customer Care" },
  { value: "100%", label: "Digital KYC Onboarding" },
];

export const PARTNER_BENEFITS = [
  {
    title: "Earn on Every Transaction",
    description:
      "Transparent commission structure across all live services — see exactly what you make.",
    icon: "HandCoins",
  },
  {
    title: "One App, Many Services",
    description:
      "Recharge, Bills, PAN, BC, RD today — IRCTC, AePS, Loans and more on the way.",
    icon: "Storefront",
  },
  {
    title: "Instant Settlement Options",
    description:
      "Wallet-to-Bank transfer, settlement and refunds managed via your saved Bank Master.",
    icon: "BankIcon",
  },
  {
    title: "Real Support",
    description:
      "Call-back requests, support tickets and distributor contact built right into the app.",
    icon: "Headset",
  },
];

export const PACKAGES = [
  {
    id: "silver",
    name: "JayesPay Silver",
    price: "₹0",
    period: "forever",
    priceNote: "Free starter package",
    tagline: "Start digital — at zero cost.",
    accentClass: "from-slate-200 to-slate-100",
    badge: null,
    features: [
      "Mobile, DTH & Data Card Recharge",
      "Gas, Electricity & Water Bill Payment",
      "Credit Card Payments",
      "LIC Premium Payments",
    ],
  },
  {
    id: "gold",
    name: "JayesPay Gold",
    price: "₹399",
    period: "one-time",
    priceNote: "Activation fee · GST extra",
    tagline: "Step up with insurance & PAN.",
    accentClass: "from-brandOrange/30 to-brandOrange/10",
    badge: null,
    features: [
      "Mobile, DTH & Data Card Recharge",
      "Gas, Electricity & Water Bill Payment",
      "Credit Card Payments",
      "LIC Premium Payments",
      "Cash Collections",
      "Bike, Car, Health & Business Insurance",
      "Apply / Update PAN Card",
    ],
  },
  {
    id: "diamond",
    name: "JayesPay Diamond",
    price: "₹999",
    period: "one-time",
    priceNote: "Activation fee · GST extra",
    tagline: "Banking, AePS and Aadhaar Pay unlocked.",
    accentClass: "from-brandBlue/30 to-brandBlue/10",
    badge: "Most Popular",
    features: [
      "Mobile, DTH & Data Card Recharge",
      "Gas, Electricity & Water Bill Payment",
      "Credit Card Payments",
      "LIC Premium Payments",
      "Cash Collections",
      "Bike, Car, Health & Business Insurance",
      "Apply / Update PAN Card",
      "DMT — Money Transfer",
      "AePS",
      "Micro ATM",
      "Mobile POS",
      "Aadhaar Pay",
      "Saving Account Opening",
    ],
  },
  {
    id: "platinum",
    name: "JayesPay Platinum",
    price: "₹4,999",
    period: "one-time",
    priceNote: "Activation fee · GST extra",
    tagline: "Full retail OS — travel, loans & gold.",
    accentClass: "from-ink900 to-ink700",
    badge: "Full Power",
    isDark: true,
    features: [
      "Everything in JayesPay Diamond",
      "Bus Booking",
      "Flight Booking",
      "Saving Account Opening",
      "Current Account Opening",
      "Personal Loan",
      "Business Loan",
      "Credit Card Apply",
      "DNFI BC Point",
      "FD Against Credit Card",
      "Silver / Gold Buy and Sell",
    ],
  },
];
